/** @jsxImportSource @emotion/react */
import React from 'react';
import { Dialog, DialogContent, useMediaQuery } from '@mui/material';
import { Z_INDEX } from '../../constants/zIndex';
import { policyStyles } from './terms-offer.styles';
import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';

const TermsOfOffer = () => {
    const isDesktop = useMediaQuery('(min-width:600px)');
    const intl = useIntl();
    const navigate = useNavigate();

    const closeHandler = () => {
        if (window.history.length > 2) {
            navigate(-1);
        } else {
            navigate('/');
        }
    };

    return (
        <Dialog
            fullScreen={!isDesktop}
            sx={{
                '& 	.MuiModal-backdrop': {
                    backgroundColor: isDesktop ? '#15457580' : '#ffffff',
                    backdropFilter: 'blur(50px)',
                },
                '&': {
                    zIndex: Z_INDEX.TERMS_MODAL,
                },
            }}
            scroll="body"
            open={true}
            slotProps={{
                backdrop: {
                    timeout: 300,
                },
            }}
            onClose={closeHandler}
            closeAfterTransition
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description">
            <DialogContent>
                <div css={policyStyles.modalContainer}>
                    <div css={policyStyles.closeButtonBlock}>
                        <div onClick={closeHandler} css={policyStyles.closeButton}>
                            &#10005;
                        </div>
                    </div>
                    <h4 css={[policyStyles.title, policyStyles.paragrapghEnd]}>
                        {intl.formatMessage({ id: 'termsOfOffer.title' })}
                    </h4>
                    <p css={[policyStyles.paragraph, policyStyles.paragrapghEnd]}>
                        {intl.formatMessage({ id: 'termsOfOffer.effectiveDate' })}
                    </p>
                    <p css={[policyStyles.title]}>
                        {intl.formatMessage({ id: 'termsOfOffer.title1' })}
                    </p>
                    <p css={[policyStyles.paragraph, policyStyles.paragrapghEnd]}>
                        {intl.formatMessage({ id: 'termsOfOffer.paragraph1' })}
                    </p>
                    <p css={[policyStyles.title]}>
                        {intl.formatMessage({ id: 'termsOfOffer.title2' })}
                    </p>
                    <p css={[policyStyles.paragraph]}>
                        {intl.formatMessage({ id: 'termsOfOffer.paragraph2' })}
                    </p>
                    <ul css={[policyStyles.listUl, policyStyles.paragrapghEnd]}>
                        <li css={policyStyles.listLi}>
                            {intl.formatMessage({ id: 'termsOfOffer.list1.1' })}
                        </li>
                        <li css={policyStyles.listLi}>
                            {intl.formatMessage({ id: 'termsOfOffer.list1.2' })}
                        </li>
                        <li css={policyStyles.listLi}>
                            {intl.formatMessage({ id: 'termsOfOffer.list1.3' })}
                        </li>
                    </ul>
                    <p css={[policyStyles.title]}>
                        {intl.formatMessage({ id: 'termsOfOffer.title3' })}
                    </p>
                    <p css={[policyStyles.paragraph]}>
                        {intl.formatMessage({ id: 'termsOfOffer.paragraph3' })}
                    </p>
                    <ul css={[policyStyles.listUl, policyStyles.paragrapghEnd]}>
                        <li css={policyStyles.listLi}>
                            {intl.formatMessage({ id: 'termsOfOffer.list2.1' })}
                        </li>
                        <li css={policyStyles.listLi}>
                            {intl.formatMessage({ id: 'termsOfOffer.list2.2' })}
                        </li>
                        <li css={policyStyles.listLi}>
                            {intl.formatMessage({ id: 'termsOfOffer.list2.3' })}
                        </li>
                    </ul>
                    <p css={[policyStyles.title]}>
                        {intl.formatMessage({ id: 'termsOfOffer.title4' })}
                    </p>
                    <p css={[policyStyles.paragraph]}>
                        {intl.formatMessage({ id: 'termsOfOffer.paragraph4' })}
                    </p>
                    <ul css={[policyStyles.listUl, policyStyles.paragrapghEnd]}>
                        <li css={policyStyles.listLi}>
                            {intl.formatMessage({ id: 'termsOfOffer.list3.1' })}
                        </li>
                        <li css={policyStyles.listLi}>
                            {intl.formatMessage({ id: 'termsOfOffer.list3.2' })}
                        </li>
                        <li css={policyStyles.listLi}>
                            {intl.formatMessage({ id: 'termsOfOffer.list3.3' })}
                        </li>
                    </ul>
                    <p css={[policyStyles.title]}>
                        {intl.formatMessage({ id: 'termsOfOffer.title5' })}
                    </p>
                    <ul css={[policyStyles.listUl, policyStyles.paragrapghEnd]}>
                        <li css={policyStyles.listLi}>
                            {intl.formatMessage({ id: 'termsOfOffer.list4.1' })}
                        </li>
                        <li css={policyStyles.listLi}>
                            {intl.formatMessage({ id: 'termsOfOffer.list4.2' })}
                        </li>
                        <li css={policyStyles.listLi}>
                            {intl.formatMessage({ id: 'termsOfOffer.list4.3' })}
                        </li>
                    </ul>
                    <p css={[policyStyles.title]}>
                        {intl.formatMessage({ id: 'termsOfOffer.title6' })}
                    </p>
                    <p css={[policyStyles.paragraph, policyStyles.paragrapghEnd]}>
                        {intl.formatMessage({ id: 'termsOfOffer.paragraph5' })}
                    </p>
                    <p css={[policyStyles.paragraph, policyStyles.paragrapghEnd]}>
                        {intl.formatMessage({ id: 'termsOfOffer.paragraph6' })}
                    </p>
                    <p css={[policyStyles.paragraph, policyStyles.paragrapghEnd]}>
                        {intl.formatMessage({ id: 'termsOfOffer.paragraph7' })}
                    </p>
                    <p css={[policyStyles.title]}>
                        {intl.formatMessage({ id: 'termsOfOffer.title7' })}
                    </p>
                    <p css={[policyStyles.paragraph]}>
                        {intl.formatMessage({ id: 'termsOfOffer.paragraph8' })}
                    </p>
                    <ul css={[policyStyles.listUl, policyStyles.paragrapghEnd]}>
                        <li css={policyStyles.listLi}>
                            {intl.formatMessage({ id: 'termsOfOffer.list5.1' })}
                        </li>
                        <li css={policyStyles.listLi}>
                            {intl.formatMessage({ id: 'termsOfOffer.list5.2' })}
                        </li>
                        <li css={policyStyles.listLi}>
                            {intl.formatMessage({ id: 'termsOfOffer.list5.3' })}
                        </li>
                    </ul>
                    <p css={[policyStyles.title]}>
                        {intl.formatMessage({ id: 'termsOfOffer.title8' })}
                    </p>
                    <p css={[policyStyles.paragraph, policyStyles.paragrapghEnd]}>
                        {intl.formatMessage({ id: 'termsOfOffer.paragraph9' })}
                    </p>
                    <p css={[policyStyles.title]}>
                        {intl.formatMessage({ id: 'termsOfOffer.title9' })}
                    </p>
                    <p css={[policyStyles.paragraph, policyStyles.paragrapghEnd]}>
                        {intl.formatMessage({ id: 'termsOfOffer.paragraph10' })}
                    </p>
                    <p css={[policyStyles.title]}>
                        {intl.formatMessage({ id: 'termsOfOffer.title10' })}
                    </p>
                    <p css={[policyStyles.paragraph, policyStyles.paragrapghEnd]}>
                        {intl.formatMessage({ id: 'termsOfOffer.paragraph11' })}
                    </p>
                    <p css={[policyStyles.title]}>
                        {intl.formatMessage({ id: 'termsOfOffer.title11' })}
                    </p>
                    <p css={[policyStyles.paragraph, policyStyles.paragrapghEnd]}>
                        {intl.formatMessage({ id: 'termsOfOffer.paragraph12' })}
                    </p>
                    <p css={[policyStyles.title]}>
                        {intl.formatMessage({ id: 'termsOfOffer.title12' })}
                    </p>
                    <p css={[policyStyles.paragraph]}>
                        {intl.formatMessage({ id: 'termsOfOffer.paragraph13' })}
                    </p>
                    <p css={[policyStyles.paragraph]}>
                        {intl.formatMessage({ id: 'termsOfOffer.paragraph14' })}
                    </p>
                    <p css={[policyStyles.paragraph, policyStyles.paragrapghEnd]}>
                        {intl.formatMessage({ id: 'termsOfOffer.paragraph15' })}
                    </p>
                    <p css={[policyStyles.paragraph, policyStyles.paragrapghEnd]}>
                        {intl.formatMessage({ id: 'termsOfOffer.paragraph16' })}
                    </p>
                    <p css={[policyStyles.paragraph]}>
                        {intl.formatMessage({ id: 'termsOfOffer.paragraph17' })}
                    </p>

                    {/* <p css={[policyStyles.paragraph]}>
                        {intl.formatMessage({ id: 'privacyPolicy.paragraph5' })}
                    </p>
                    <ul css={[policyStyles.listUl, policyStyles.paragrapghEnd]}>
                        <li css={policyStyles.listLi}>
                            {intl.formatMessage({ id: 'privacyPolicy.list2.1' })}
                        </li>
                        <li css={policyStyles.listLi}>
                            {intl.formatMessage({ id: 'privacyPolicy.list2.2' })}
                        </li>
                        <li css={policyStyles.listLi}>
                            {intl.formatMessage({ id: 'privacyPolicy.list2.3' })}
                        </li>
                    </ul>
                    <p css={[policyStyles.title]}>
                        {intl.formatMessage({ id: 'privacyPolicy.title2' })}
                    </p>
                    <p css={[policyStyles.paragraph]}>
                        {intl.formatMessage({ id: 'privacyPolicy.paragraph6' })}
                    </p>
                    <ul css={[policyStyles.listUl, policyStyles.paragrapghEnd]}>
                        <li css={policyStyles.listLi}>
                            {intl.formatMessage({ id: 'privacyPolicy.list3.1' })}
                        </li>
                        <li css={policyStyles.listLi}>
                            {intl.formatMessage({ id: 'privacyPolicy.list3.2' })}
                        </li>
                        <li css={policyStyles.listLi}>
                            {intl.formatMessage({ id: 'privacyPolicy.list3.3' })}
                        </li>
                        <li css={policyStyles.listLi}>
                            {intl.formatMessage({ id: 'privacyPolicy.list3.4' })}
                        </li>
                        <li css={policyStyles.listLi}>
                            {intl.formatMessage({ id: 'privacyPolicy.list3.5' })}
                        </li>
                    </ul>
                    <p css={[policyStyles.title]}>
                        {intl.formatMessage({ id: 'privacyPolicy.title3' })}
                    </p>
                    <p css={[policyStyles.paragraph]}>
                        {intl.formatMessage({ id: 'privacyPolicy.paragraph7' })}
                    </p>
                    <p css={[policyStyles.paragraph]}>
                        {intl.formatMessage({ id: 'privacyPolicy.paragraph8' })}
                    </p>
                    <p css={[policyStyles.paragraph]}>
                        {intl.formatMessage({ id: 'privacyPolicy.paragraph9' })}
                    </p>
                    <ul css={policyStyles.listUl}>
                        <li css={policyStyles.listLi}>
                            {intl.formatMessage({ id: 'privacyPolicy.list4.1' })}
                        </li>
                        <li css={policyStyles.listLi}>
                            {intl.formatMessage({ id: 'privacyPolicy.list4.2' })}
                        </li>
                    </ul>
                    <p css={[policyStyles.paragraph]}>
                        {intl.formatMessage({ id: 'privacyPolicy.paragraph10' })}
                    </p>
                    <p css={[policyStyles.paragraph]}>
                        {intl.formatMessage({ id: 'privacyPolicy.paragraph11' })}
                    </p>
                    <ul css={[policyStyles.listUl, policyStyles.paragrapghEnd]}>
                        <li css={policyStyles.listLi}>
                            {intl.formatMessage({ id: 'privacyPolicy.list5.1' })}
                        </li>
                        <li css={policyStyles.listLi}>
                            {intl.formatMessage({ id: 'privacyPolicy.list5.2' })}
                        </li>
                    </ul>
                    <p css={[policyStyles.title]}>
                        {intl.formatMessage({ id: 'privacyPolicy.title4' })}
                    </p>
                    <p css={[policyStyles.paragraph]}>
                        {intl.formatMessage({ id: 'privacyPolicy.paragraph12' })}
                    </p>
                    <ul css={[policyStyles.listUl, policyStyles.paragrapghEnd]}>
                        <li css={policyStyles.listLi}>
                            {intl.formatMessage({ id: 'privacyPolicy.list6.1' })}
                        </li>
                        <li css={policyStyles.listLi}>
                            {intl.formatMessage({ id: 'privacyPolicy.list6.2' })}
                        </li>
                        <li css={policyStyles.listLi}></li>
                    </ul>
                    <p css={[policyStyles.title]}>
                        {intl.formatMessage({ id: 'privacyPolicy.title5' })}
                    </p>
                    <p css={[policyStyles.paragraph, policyStyles.paragrapghEnd]}>
                        {intl.formatMessage({ id: 'privacyPolicy.paragraph13' })}
                    </p>
                    <p css={[policyStyles.title]}>
                        {intl.formatMessage({ id: 'privacyPolicy.title6' })}
                    </p>
                    <p css={[policyStyles.paragraph]}>
                        {intl.formatMessage({ id: 'privacyPolicy.paragraph14' })}
                    </p>
                    <ul css={[policyStyles.listUl]}>
                        <li css={policyStyles.listLi}>
                            {intl.formatMessage({ id: 'privacyPolicy.list7.1' })}
                        </li>
                        <li css={policyStyles.listLi}>
                            {intl.formatMessage({ id: 'privacyPolicy.list7.2' })}
                        </li>
                    </ul>
                    <p css={[policyStyles.paragraph, policyStyles.paragrapghEnd]}>
                        {intl.formatMessage({ id: 'privacyPolicy.paragraph15' })}
                    </p>
                    <p css={[policyStyles.title]}>
                        {intl.formatMessage({ id: 'privacyPolicy.title7' })}
                    </p>
                    <p css={[policyStyles.paragraph, policyStyles.paragrapghEnd]}>
                        {intl.formatMessage({ id: 'privacyPolicy.paragraph16' })}
                    </p>
                    <p css={[policyStyles.title]}>
                        {intl.formatMessage({ id: 'privacyPolicy.title8' })}
                    </p>
                    <p css={[policyStyles.paragraph, policyStyles.paragrapghEnd]}>
                        {intl.formatMessage({ id: 'privacyPolicy.paragraph17' })}
                    </p>
                    <p css={[policyStyles.title]}>
                        {intl.formatMessage({ id: 'privacyPolicy.title9' })}
                    </p>
                    <p css={[policyStyles.paragraph, policyStyles.paragrapghEnd]}>
                        {intl.formatMessage({ id: 'privacyPolicy.paragraph18' })}
                    </p>
                    <p css={[policyStyles.title]}>
                        {intl.formatMessage({ id: 'privacyPolicy.title10' })}
                    </p>
                    <p css={[policyStyles.paragraph]}>
                        {intl.formatMessage({ id: 'privacyPolicy.paragraph19' })}
                    </p>
                    <p css={[policyStyles.paragraph]}>
                        {intl.formatMessage({ id: 'privacyPolicy.paragraph20' })}
                    </p>
                    <p css={[policyStyles.paragraph, policyStyles.paragrapghEnd]}>
                        {intl.formatMessage({ id: 'privacyPolicy.paragraph21' })}
                    </p>
                    <p css={[policyStyles.paragraph, policyStyles.paragrapghEnd]}>
                        {intl.formatMessage({ id: 'privacyPolicy.paragraph22' })}
                    </p>
                    <p css={[policyStyles.paragraph]}>
                        {intl.formatMessage({ id: 'privacyPolicy.paragraph23' })}
                    </p> */}
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default TermsOfOffer;
